/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import logo from '../Resources/logo_bw.svg';
import vantagex from '../Resources/vantagex.png';
import latoken from '../Resources/latoken.png';
import s from './Header.module.scss';

const Header = () => {
  const [price, setPrice] = useState(0);
  const { i18n } = useTranslation();

  const language = i18n.language.split('-')[0];

  useEffect(() => {
    fetch(`https://prover.io/contractInfo/pricePF.json`)
      .then(res => res.json())
      .then(json => setPrice(json.PF));
  }, []);

  const changeLanguage = lang => () => {
    i18n.changeLanguage(lang);
  };

  return (
    <header className={s.header}>
      <a href="https://prover.io">
        <img src={logo} alt="Prover Logo" className={s.logo} />
      </a>
      <ul className={s.main}>
        <li className={s.withGroup}>
          <ul className={cx(s.group, s.red)}>
            <li className={s.title}>Product</li>
            <li>
              <a href="https://product.prover.io/">Try it!</a>
            </li>
            <li>
              <a href="https://product.prover.io/swype-id#upload-file">
                Check file
              </a>
            </li>
            <li>
              <a href="https://enterprise.prover.io/">Enterprise</a>
            </li>
          </ul>
        </li>
        {/*<li>
          <a href="https://prover.io/investorsNEM.php">RichList</a>
        </li>*/}
        <li>
          <a href="https://prover.io/affiliate.php">Affiliate</a>
        </li>
        <li className={s.active}>
          <a href="https://referral.prover.io">Referral</a>
        </li>
        <li className={s.withGroup}>
          <ul className={cx(s.group, s.red, s.buy)}>
            <li className={s.title}>Buy PF: {price}$</li>
            <li>
              <a
                href="https://vantagex.io/trade/nem:xem/prover:proof"
                target="_blank"
                rel="noopener noreferrer"
                className="menu__link"
              >
                <img src={vantagex} alt="VantageX" className={s.stock} />
                VantageX
              </a>
            </li>
            <li>
              <a
                href="https://latoken.com/exchange/PF-USDT"
                target="_blank"
                rel="noopener noreferrer"
                className="menu__link"
              >
                <img src={latoken} alt="LATOKEN" className={s.stock} />
                LATOKEN
              </a>
            </li>
          </ul>
        </li>
        <li className={s.gray}>
          <a
            href={`https://prover.io/assets/White_Paper_${
              i18n.language === 'vi' ? 'vn' : 'en'
            }.pdf?0702`}
          >
            Whitepaper
          </a>
        </li>
        <li className={s.gray}>
          <a href="https://prover.io/#follow">Social</a>
        </li>
        <li className={cx(s.gray, s.withGroup)} key={Math.random()}>
          <ul className={s.group}>
            <li className={cx(s.title, s.gray)}>{language}</li>
            <li onClick={changeLanguage('en')}>
              <span>en</span>
            </li>
            <li onClick={changeLanguage('ru')}>
              <span>ru</span>
            </li>
            <li onClick={changeLanguage('vi')}>
              <span>vi</span>
            </li>
          </ul>
        </li>
      </ul>
    </header>
  );
};

export default Header;
